<template>
  <div id="taskIndicators">
    <!-- <div class="task-1 task-wrap">
      <div class="title">全项目制项目</div>
      <ProgressBar :lists="beginLists"></ProgressBar>
    </div>
    <div class="task-1 task-wrap">
      <div class="title">BSC项目</div>
      <ProgressBar :lists="endLists"></ProgressBar>
    </div> -->
    <div class="ss-chart">
      <DomeEchartWrap ref="cProduct" id="c-product" class="canvas-wrap"></DomeEchartWrap>
    </div>
    <!-- <div class="task-1 task-wrap">
      <div class="title">全项目制项目</div>
      <div class="can-wrap">
        <el-button
          class="btn-point"
          size="mini"
          type="primary"
          @click="gopj(false)"
        >
          项目评价
        </el-button>
        <canvas class="can-dom" id="task1"></canvas>
      </div>
    </div>
    <div class="task-1 task-wrap">
      <div class="title">BSC项目</div>
      <div class="can-wrap">
        <el-button
          class="btn-point"
          size="mini"
          type="primary"
          @click="gopj(false)"
        >
          项目评价
        </el-button>
        <canvas class="can-dom" id="task2"></canvas>
      </div>
    </div>
    <div class="task-1 task-wrap">
      <div class="title">数字化管理任务</div>
      <div class="can-wrap">
        <el-button
          class="btn-point"
          size="mini"
          type="primary"
          @click="gopj(true)"
        >
          任务评价
        </el-button>
        <canvas class="can-dom" id="task3"></canvas>
      </div>
    </div> -->
  </div>
</template>

<script>
import { onMounted, reactive, ref, getCurrentInstance, inject } from '@vue/composition-api'
import ProgressBar from '../components/progressBar.vue'
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'
export default {
  name: 'TaskIndicators',
  props: [

  ],
  setup (props, { root }) {
    const vm = getCurrentInstance()

    function gopj (val) {
      console.log(vm)
      vm.setupContext.root.$router.push({
        path: '/btaskEvaluation',
        query: {
          isProject: val ? 1 : 0
        }
      })
    }

    /// ////////
    let cProduct = ref(null)
    let cProductDate = ref(null)
    let base = +new Date(1968, 9, 3)
    let oneDay = 24 * 3600 * 1000
    let date = []
    let data1 = [
      {
        value: 10,
        sj: '项目1:开始项目会议'
      },
      null,
      null,
      {
        value: 30,
        sj: '项目1:项目测试'
      }
    ]
    let data2 = [
      {
        value: 10,
        sj: '项目2:开始项目会议'
      },
      null,
      {
        value: 30,
        sj: '项目2:项目第一版上线'
      },
      null
    ]
    let data3 = [
      {
        value: 30,
        sj: '项目3:开始立项'
      },
      {
        value: 20,
        sj: '项目3:开始招标'
      },
      {
        value: 30,
        sj: '项目3:项目第一版上线'
      },
      {
        value: 10,
        sj: '项目3:项目第二版上线'
      }
    ]
    for (let i = 1; i < 51; i++) {
      var now = new Date((base += oneDay))
      // date.push([now.getFullYear(), now.getMonth() + 1, now.getDate()].join('/'))
      date.push({
        value: `w${i}`,
        sj: '项目今天开始'
      })
      data1.push({
        // value: Math.round((Math.random() * Math.random()) * 10000),
        value: 10,
        sj: `项目1:开始项目`
      })
      data2.push({
        // value: Math.round((Math.random() * Math.random()) * 10000),
        value: Math.random() > 0.5 ? 10 : 20,
        sj: `项目2:开始会议`
      })
      data3.push({
        // value: Math.round((Math.random() * Math.random()) * 10000),
        value: Math.random() > 0.5 ? 10 : 20,
        sj: `项目3:开始会议`
      })
    }
    let project = {
      '项目1': data1,
      '项目2': data2,
      '项目3': data3
    }
    let echoption = {
      legend: {
        data: ['项目1'],
        right: 20
      },
      grid: {
        show: true,
        top: 70,
        bottom: 80,
        left: 100,
        right: 20,
        backgroundColor: '#fff',
        borderWidth: 0
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        position: function (pt) {
          return [pt[0], '10%']
        },
        formatter: function (params, ticket, cb) {
          let str = ''
          return params.map(v => {
            if (v.seriesName === 'empty' || !v || !v.data) { return false }
            return `<div>
                  <span class="pro-date">${v.axisValueLabel}</span> <span>${v.data.sj}</span>
              </div>`
          }).filter(Boolean).join('')
        }
      },
      title: {
        left: 'center',
        text: '2022年项目周期历程'
      },
      xAxis: {
        type: 'category',
        // boundaryGap: false,
        boundaryGap: ['50%', '50%'],
        data: date,
        axisLabel: {
          fontSize: 18,
          fontWeight: 'bold'
        },
        axisTick: {
          length: 10
        }
      },
      yAxis: [
        {
          alignTicks: true,
          type: 'value',
          boundaryGap: [0, '100%'],
          interval: 1,
          max: 7,
          axisLabel: {
            formatter: function (valuse, index) {
              let data = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
              return data[index]
            }
          }
        }
      ],
      dataZoom: [
        {
          start: 0,
          end: 10
        }
      ],
      series: [
        // {
        //   name: 'empty',
        //   type: 'bar',
        //   stack: 'ss',
        //   itemStyle: {
        //     borderColor: 'transparent',
        //     color: 'transparent'
        //   },
        //   emphasis: {
        //     itemStyle: {
        //       borderColor: 'transparent',
        //       color: 'transparent'
        //     }
        //   },
        //   data: [1, null, null, 2]
        // },
        // {
        //   name: '项目1',
        //   type: 'bar',
        //   stack: 'ss',
        //   symbol: 'none',
        //   sampling: 'lttb',

        //   // areaStyle: {
        //   //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //   //     {
        //   //       offset: 0,
        //   //       color: 'rgb(255, 158, 68)'
        //   //     },
        //   //     {
        //   //       offset: 1,
        //   //       color: 'rgb(255, 70, 131)'
        //   //     }
        //   //   ])
        //   // },
        //   data: data1
        // }
      ]
    }

    let userId = inject('userId')
    onMounted(() => {
      // cProductDate.value.setEchartOption(echoption1)
      getBscTaskLists()
    })
    function getBscTaskLists () {
      vm.proxy.$service.fetch({
        url: '/api/bsc/task/index',
        params: {
          empNo: userId// CC1491
        }
      }).then(res => {
        let list = res.reduce((a, b) => {
          let { taskId, taskName, taskVOList } = b
          let week52Data = [].fill(null, 0, 52)
          let week52Empty = [].fill(null, 0, 52)
          let newArr = []
          // taskVOList.reduce((ia, ib) => {
          //   let { week, happenTime, event, taskName } = ib
          //   ia[week] = {
          //     value: happenTime,
          //     sj: `${taskName}${event}`
          //   }
          //   return ia
          // }, [])
          taskVOList.forEach(v => {
            let { week, happenTime, event, taskName } = v
            week52Data[week] = {
              value: 1,
              sj: `${taskName}${event}`,
              taskName: taskName
            }
            week52Empty[week] = happenTime - 1
          })
          newArr.push(week52Data)
          newArr.push(week52Empty)
          a.push(newArr)
          return a
        }, [])
        console.log(list)
        initSeriest(list)
      })
    }
    function initSeriest (list) {
      let series = list.reduce((a, b, index) => {
        let [val, emp] = b

        console.log(emp)
        a.push({
          name: 'empty',
          type: 'bar',
          stack: `ss`,
          itemStyle: {
            borderColor: 'transparent',
            color: 'transparent'
          },
          emphasis: {
            itemStyle: {
              borderColor: 'transparent',
              color: 'transparent'
            }
          },
          data: [...emp]
        })
        a.push({
          name: `项目${val.filter(Boolean)[0]?.taskName}`,
          type: 'bar',
          stack: `ss`,
          symbol: 'none',
          sampling: 'lttb',
          data: [...val]
        })
        return a
      }, [])
      echoption.series = [...series]
      console.log(series)
      cProduct.value.setEchartOption(echoption)
    }
    return {
      gopj, cProduct, dataLists: data1, cProductDate
    }
  },
  components: {
    // ProgressBar
    DomeEchartWrap
  }
}
</script>

<style scoped lang="stylus">
.task-wrap
  display: flex;
  align-items: center;
  .title
    writing-mode: tb-rl
    font-size: 30px
    font-weight: bolder
    padding 0 15px

.can-wrap
  flex 1 0
  height 500px
  position: relative
  .can-dom
    width 100%
    height 100%
  .btn-point
    position: absolute
    right 20px

.ss-chart
  width 100%
  height 500px

.ss-chart
  >>> .pro-date
        margin-right 20px

</style>
